module.exports = __webpack_public_path__ + "images/Env2-631651f7f31b3cfdda774df14bfb612e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/Env2.jpg
// module id = 38
// module chunks = 0